import React, {useEffect, Suspense} from 'react';
import {Box, Grid} from '@mui/material';
import './AccountOverview.css';
import {useAccountContext, useAccountFull} from '../../contexts/AccountContext';
import Loading from '../Loading/Loading';
import {ContactsGridItems} from './AccountContactGridItems';
import {AccountGridItems} from './AccountGridItems';
import {useRecentClients} from '../../hooks/useRecentClients';
import {DocumentGenerator} from '../DocumentGenerator/DocumentGenerator';
import {AccountPlans} from './AccountPlans';
import {FeatureBoundary} from '../../contexts/FeatureBoundary';
import {GlobalPermissionEnum, OVModelsEnum} from '../../schema-types/globalTypes';
import {ContactActionsContextProvider} from '../ContactActions/ContactActionsContext';
import {EmailAuditWrapped} from '../../pages/EmailAuditPage/EmailAuditPage';
import {Panel} from '../Panel/Panel';
import {themeColors} from '../../theme/Theme';
import {AccountNotes} from './AccountNotes';

function AccountOverview() {
  const {account, accountLoading, accountId} = useAccountContext();
  const {accountFull} = useAccountFull();
  const {removeRecentSearch} = useRecentClients();
  useEffect(() => {
    // if account doesnt exist, then remove from recent searches
    if (!accountLoading && !account) {
      if (accountId) {
        removeRecentSearch(accountId);
      }
    }
  }, [account, accountLoading]);

  if (accountLoading) {
    return <Loading />;
  }
  if (!account) {
    return <div>Account not found</div>;
  }

  return (
    <Grid container spacing={4}>
      <AccountGridItems accountFull={accountFull} />
      <Suspense fallback={<Loading />}>
        <ContactActionsContextProvider accountFull={accountFull}>
          <ContactsGridItems />
        </ContactActionsContextProvider>
      </Suspense>
      <Suspense fallback={<Loading />}>
        <AccountPlans />
      </Suspense>
      <FeatureBoundary
        showErrorIfDenied={false}
        features={[
          GlobalPermissionEnum.can_access_notes,
          GlobalPermissionEnum.can_access_ehons_notes_goals,
        ]}
      >
        <Grid item xs={12}>
          <Panel title={`${account?.name} notes`} color={themeColors.amber}>
            <AccountNotes />
          </Panel>
        </Grid>
      </FeatureBoundary>
      <FeatureBoundary
        features={[GlobalPermissionEnum.can_access_xperidoc]}
        showErrorIfDenied={false}
      >
        <Suspense fallback={<Loading />}>
          <DocumentGenerator entity="account" />
        </Suspense>
      </FeatureBoundary>
      <Suspense fallback={<Loading />}>
        <Grid item xs={12} mb={10}>
          <Panel color={themeColors.lightPink} title="Latest emails to account">
            <Box mb={4}>
              <EmailAuditWrapped
                formFields={[]}
                forcedAccount={account}
                initialValueOverrides={{page: 1}}
              />
            </Box>
          </Panel>
        </Grid>
      </Suspense>
    </Grid>
  );
}

export default AccountOverview;
